import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetLanguages = () => {
    const {
        isFetching: isLoading, data: languages, error,
    } = useQuery({
        queryKey: ["languages"],
        queryFn: () => axiosManager.get$("/parent/api/languages").then((response) => response?.data),
        retry: 0,
    });

    const languagesOptions = (languages || []).map((item) => ({
        value: item.languageCode,
        label: item.name,
        id: item.languageCode,
    }));

    return {
        isLoading,
        languages: languages || [],
        error,
        languagesOptions,
    };
};
